import { Card, CardContent, CardHeader, CardTitle, Skeleton } from '@/design-system/components/ui';

interface Props {
  chartTitle: string;
}

const SkeletonChartCard = ({ chartTitle }: Props) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{chartTitle}</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Skeleton chart */}
        <div className="tw:h-[300px]">
          <Skeleton variant="rectangular" style={{ height: '100%' }} />
        </div>

        {/* Skeleton conversion selector */}
        <div className="tw:flex tw:justify-end tw:p-4 tw:pr-0">
          <Skeleton variant="rectangular" width={200} height={32} />
        </div>
      </CardContent>
    </Card>
  );
};

export default SkeletonChartCard;
